export enum RedirectUrlOriginTypes {
    CALLBACK_URL = 'Callback URL',
    REDIRECT = "Redirect",
    PROPERTY_REDIRECT_URL = "Property Redirect URL",
    PROFILE_REDIRECT_URL = "Profile Redirect URL"
}